import { Box, Grid, Theme, useMediaQuery } from '@mui/material';
import { SigninFormSkeleton } from '../../components/signin-form/SigninFormSkeleton';
import { AuthFormPresentationSkeleton } from '../../containers/auth-form/AuthFormPresentationSkeleton';

export const SignInPageSkeleton: React.FC = () => {
  const isNotMobile = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));
  return (
    <Grid container spacing={{ xs: 0, md: 2.5 }}>
      {isNotMobile && (
        <Grid item xs={12} md={6}>
          <AuthFormPresentationSkeleton />
        </Grid>
      )}
      <Grid item xs={12} md={6}>
        <Box className={isNotMobile ? 'container-fluid-right' : 'container-fluid'} sx={{ height: 1 }}>
          <Grid container sx={{ height: 1 }} alignItems="center">
            <Grid xs item>
              <SigninFormSkeleton />
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
};
